<template>
    <div>

        <vue-headful title="Disciplinary Action Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/employees/disciplinary-actions#alerts">
                        Disciplinary Actions
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    <template v-if="!id">New Email Alert</template>
                    <template v-else>
                        <template v-if="!loading">Edit {{ alert.alert_name }}</template>
                    </template>
                </li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-4 col-12">
                    <div class="card">
                        <div class="card-header">Alert Details</div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div :class="{'col-md-4': true, 'text-danger': errors.alert_name ,'text-muted': !errors.alert_name}">Alert Name:</div>
                                <div class="col-md-8">
                                    <input type="text" name="alert_name" v-model="alert.alert_name" :class="{'form-control': true, 'is-invalid': errors.alert_name}" placeholder="Enter Alert Name" />

                                    <span v-if="errors.alert_name" class="text-danger">
                                        <span v-for="error in errors.alert_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Active:</div>
                                <div class="col-md-8">
                                    <b-form-checkbox v-model="alert.is_active" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Description:</div>
                                <div class="col-md-8">
                                    <textarea class="form-control" placeholder="Enter Alert Description (Optional)" v-model="alert.description" rows="4">{{ alert.description }}</textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            Conditions
                            <button class="btn btn-sm btn-info" type="button" v-on:click="conditions.push({disc_field_id: null, logic: null, cond_value: null})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <strong>WHEN:</strong>
                            <ol>
                                <li v-for="(cond, i) in conditions" class="mb-2">
                                    <a href="javascript:void" class="text-danger btn-link" v-on:click="deleteCondition(i);"><i class="fa fa-trash"></i></a>

                                    <b-form-select class="form-control" v-model="cond.disc_field_id" :options="fieldOptions" />

                                    <b-form-select class="form-control" v-model="cond.logic" :options="logicOptions" />

                                    <template v-if="cond.disc_field_id && fields[cond.disc_field_id].field_type && fields[cond.disc_field_id].field_type == 'boolean'">
                                        <select class="form-control" v-model="cond.cond_value">
                                            <option :value="null">-- Select Yes or No --</option>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                    </template>
                                    <template v-if="cond.disc_field_id && fields[cond.disc_field_id].field_type && fields[cond.disc_field_id].field_type == 'date'">

                                    </template>
                                    <template v-if="cond.disc_field_id && fields[cond.disc_field_id].field_type && fields[cond.disc_field_id].field_type == 'dropdown'">
                                        <template v-if="cond.logic == 'DEACTIVATED' || cond.logic == 'DEACTIVATED'">
                                            <multiselect v-model="cond.cond_value.split(',')" placeholder="Select Values" :options="fields[cond.disc_field_id].options" :multiple="true" :taggable="true"></multiselect>
                                        </template>
                                        <template v-else>
                                            <select class="form-control"
                                                v-model="cond.cond_value_formatted"
                                                :multiple="(cond.logic == 'Is Any' || cond.logic == 'Is Not Any' ? true : false)">
                                                <option :value="null">-- Select {{ fields[cond.disc_field_id].field_label }}--</option>
                                                <template v-for="(opt, j) in fields[cond.disc_field_id].options">
                                                    <option :value="j">{{ opt }}</option>
                                                </template>
                                            </select>
                                        </template>

                                    </template>
                                    <template v-if="cond.disc_field_id && fields[cond.disc_field_id].field_type && fields[cond.disc_field_id].field_type == 'enum'">
                                        <select class="form-control" v-model="cond.cond_value_formatted">
                                            <option :value="null">-- Select {{ fields[cond.disc_field_id].field_label }}--</option>
                                            <template v-for="(opt, j) in fields[cond.disc_field_id].options">
                                                <option :value="j">{{ opt }}</option>
                                            </template>
                                        </select>
                                    </template>
                                    <template v-if="cond.disc_field_id && fields[cond.disc_field_id].field_type
                                                    && (fields[cond.disc_field_id].field_type == 'text' ||
                                                        fields[cond.disc_field_id].field_type == 'int' ||
                                                        fields[cond.disc_field_id].field_type == 'decimal')">
                                        <input type="text" class="form-control" v-model="cond.cond_value" placeholder="Enter Value" />
                                    </template>

                                    <span v-if="errors['conditions['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['conditions['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header">
                            Recipients
                            <button class="btn btn-sm btn-info" type="button" v-on:click="recipients.push({target_type: null, target_value: null})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <strong>Send Email To:</strong>
                            <ol>
                                <li v-for="(recip, i) in recipients" :key="recip.id" class="mb-2">
                                    <a href="javascript:void" class="text-danger btn-link" v-on:click="deleteRecipient(i);"><i class="fa fa-trash"></i></a>

                                    <b-form-select class="form-control" v-model="recip.target_type" :options="recipientOptions" />

                                    <span v-if="recip.target_type != 'Supervisor' && recip.target_type != 'Violator'">=</span>

                                    <span v-if="recip.target_type == 'Employee'" class="d-lg-inline-block" style="width: 400px;">
                                        <employee-select
                                            :selectedValues="recip.target_label ? {EmployeeId: recip.target_label.EmployeeId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName, EmployeeNumber: recip.target_label.EmployeeNumber} : null"
                                            @vselected="function(employee){ recip.target_value = employee.EmployeeId; }"
                                            :hasError="errors['recipients['+i+']'] ? true : false" />
                                    </span>

                                    <template v-if="recip.target_type == 'Employee Title'">
                                        <!-- <input type="text" v-model="recip.target_value" placeholder="Enter an Employee Title/Position" class="form-control" /> -->
                                        <b-form-select v-model="recip.target_value" :options="titleOptions" :class="{'is-invalid': errors['recipients['+i+']']}" />
                                    </template>

                                    <template v-if="recip.target_type == 'Email'">
                                        <input type="text" v-model="recip.target_value" placeholder="Enter an Email Address" class="form-control" />
                                    </template>

                                    <template v-if="recip.target_type == 'Role'">
                                        <b-form-select class="form-control" v-model="recip.target_value" :options="roleOptions" />
                                    </template>

                                    <span v-if="recip.target_type == 'User'" class="d-lg-inline-block" style="width: 400px;">
                                        <user-select
                                            :selectedValues="recip.target_label ? {UserId: recip.target_label.UserId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName} : null"
                                            @vuselected="function(user){ recip.target_value = user.UserId; }"
                                            :hasError="errors['recipients['+i+']'] ? true : false" />
                                    </span>

                                    <span v-if="errors['recipients['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['recipients['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>

                            <div v-if="errors.recipients" class="alert alert-danger">
                                <span v-for="(error, key) in errors.recipients"><template v-if="key > 0">, </template>{{ error }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveAlert()" :disabled="saving">
                <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                <template v-else>Save Disciplinary Email Alert</template>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                alert: {},
                fields: [],
                conditions: [],
                recipients: [],
                recipientTypes: [],
                titles: [],
                roles: [],
            }
        },

        computed: {

            fieldOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Field --'}
                ];

                //Field Arrya
                var fieldArray = Object.values(this.fields);

                //Loop
                for(var i = 0; i < fieldArray.length; i++)
                {
                    //Push
                    options.push({value: fieldArray[i].id, text: fieldArray[i].field_label});
                }

                //Send it
                return options;
            },

            recipientOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Target Type --'}
                ];

                //Loop
                for(var i = 0; i < this.recipientTypes.length; i++)
                {
                    //Push
                    options.push({value: this.recipientTypes[i], text: this.recipientTypes[i]});
                }

                //Send it
                return options;
            },

            roleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Role --'}
                ];

                //Loop
                for(var i = 0; i < this.roles.length; i++)
                {
                    //Push
                    options.push({value: this.roles[i].id, text: this.roles[i].name});
                }

                //Send it
                return options;
            },

            logicOptions(){
                return [
                    {value: null, text: '-- Select Logic --'},
                    {value: 'Equals', text: '='},
                    {value: 'Is Any', text: 'has any'},
                    {value: 'Is Not Any', text: 'none of'},
                ];
            },

            titleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Title --'}
                ];

                //Loop
                for(var i = 0; i < this.titles.length; i++)
                {
                    //Push
                    options.push({value: this.titles[i], text: this.titles[i]});
                }

                //Send it
                return options;
            },
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('employees/disciplinary-actions/alerts/edit' + (this.id ? '/' + this.id : ''))
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                        this.fields = res.data.fields;
                        this.conditions = this.alert.conditions;
                        this.recipients = this.alert.recipients;
                        this.recipientTypes = res.data.recipientTypes;
                        this.roles = res.data.roles;
                        this.titles = res.data.titles;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteCondition(key){
                //Splice
                this.conditions.splice(key, 1);
            },

            deleteRecipient(key){
                //Splice
                this.recipients.splice(key, 1);
            },

            saveAlert(){
                //Saving Flag
                this.saving = true;
                this.errors = {};

                //Set the values
                this.alert.conditions = this.conditions;
                this.alert.recipients = this.recipients;

                //Fix the conditions
                for(var i = 0; i < this.alert.conditions.length; i++)
                {
                    //Check it
                    if(this.alert.conditions[i].cond_value_formatted)
                    {
                        this.alert.conditions[i].cond_value = this.alert.conditions[i].cond_value_formatted;
                    }
                }

                //Send it
                this.$http.post('employees/disciplinary-actions/alerts/edit', this.alert)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Disciplinary Email Alert Saved');

                        //Send to the View
                        this.$router.push('/employees/disciplinary-actions#alerts');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Save Alert');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            }
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
